import React from 'react';
import { makeStyles } from '@mui/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import SerieForm from './SerieForm';
import { useSelector } from "react-redux";
import SerieTable from "./SerieTable";
import Typography from '@mui/material/Typography';

const useStyles = makeStyles({
    container: {
        marginTop: '20px'
    },
    paper: {
        padding: '20px',
    },
    table: {
        paddingTop: '20px;',
        margin: '20px'
    },
    title: {
        marginBottom: '20px'
    },
    cursorLink: {
        cursor: 'pointer'
    }
});

export default function SerieContainer() {
    const serie = useSelector(state => state.serie);
    const classes = useStyles();

    return (
        <div>
            <CssBaseline />
            <Container className={classes.paper} component={Paper}>
                <Typography className={classes.title} variant="h6">
                    Séries
                </Typography>
                {serie ?
                    <>
                        <Grid style={{ marginBottom: '20px' }} container spacing={2}>
                            <Grid size={4}>
                                <SerieForm />
                            </Grid>

                        </Grid>
                    </> :
                    <SerieTable />
                }

            </Container>
        </div>
    );
}